export type TaskCard = {
  id: string;
  code: string;
  status: string;
  titulo: string;
  descricao: string;
  projetoId: number;
  dataEstimativa: Date;
  dataCriacao: Date;
  userCriadorId: string;
  userResponsavelId: string;
  projeto: {
    descricao: string;
  };
  userCriador: {
    nome: string;
  };
  userResponsavel: {
    nome: string;
  };
}

export type CreateTaskCard = {
  id?: string;
  code: string;
  status: string;
  titulo: string;
  descricao: string;
  projetoId: number;
  dataEstimativa: Date;
  dataCriacao: Date;
  userCriadorId: string;
  userResponsavelId: string;
}

export enum ColumnStatusId {
  PENDING = "pending",
  CONFIRMED = "confirmed",
  SENT = "sent",
  DELIVERED = "delivered",
}

export const defaultCols = [
  {
    id: "pending" as const,
    title: "Pendente",
  },
  {
    id: "confirmed" as const,
    title: "Confirmado",
  },
  {
    id: "sent" as const,
    title: "Enviado",
  },
  {
    id: "delivered" as const,
    title: "Entregue",
  },
];